@if (!createFieldInterventionService.entities().length || createFieldInterventionService.isError()) {
    @if (createFieldInterventionService.isLoading()) {
        <app-loading />
    } @else {
        <app-create-field-intervention-information
            size="xl"
            [icon]="['fal', 'circle-exclamation']"
            [subTitle]="createFieldInterventionService.errorMessage()"
            [title]="'unableToDisplayEntities'" />
    }
} @else {
    <div>
        <app-custom-table
            [columns]="customColumns"
            [headerCheckboxState]="createFieldInterventionService.headerCheckboxState()"
            [isSelectable]="true"
            (sortEvent)="sort($event)"
            (toggleAllSelectedEvent)="createFieldInterventionService.handleHeaderCheckBox()">
            @if (createFieldInterventionService.isLoading()) {
                <tr>
                    <td
                        class="text-center h-full align-middle bg-white"
                        colspan="100%">
                        <app-loading />
                    </td>
                </tr>
            } @else {
                @for (dataEntity of createFieldInterventionService.entities(); track dataEntity.uuid) {
                    <tr
                        class="cursor-pointer"
                        (click)="createFieldInterventionService.handleSelectEntity($event, dataEntity)">
                        <td>
                            <app-checkbox
                                [checkboxState]="createFieldInterventionService.rowCheckboxState()[dataEntity.uuid]" />
                        </td>
                        <td>{{ dataEntity.businessIdentifier }}</td>
                        @for (column of bookmarkedAttributes; track column) {
                            <td>{{ dataEntity[column] | stringify }}</td>
                        }
                    </tr>
                }
            }
        </app-custom-table>
    </div>
}
